import { useEffect, useRef } from "react";

type UseDeleteElementMutationObserverArgs = {
  elementId: string;
  isMutationObserverActive: boolean;
};

type UseDeleteElementMutationObserver = (args: UseDeleteElementMutationObserverArgs) => void;

export const useDeleteElementMutationObserver: UseDeleteElementMutationObserver = ({
  elementId,
  isMutationObserverActive,
}) => {
  const mutationObserverRef = useRef<MutationObserver | null>(null);

  useEffect(() => {
    if (!isMutationObserverActive) {
      mutationObserverRef.current?.disconnect();
      return;
    }

    mutationObserverRef.current = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList") {
          mutation.removedNodes.forEach((node) => {
            if (node instanceof HTMLElement && node.id === elementId) {
              window.location.reload();
            }
          });
        }
      });
    });

    mutationObserverRef.current.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => mutationObserverRef.current?.disconnect();
  }, [elementId, isMutationObserverActive]);
};
